/* eslint-disable radix */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable no-plusplus */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect, useState } from 'react';
import { Form } from '@unform/web';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { MdModeEdit, MdDelete } from 'react-icons/md';

import Input from '~/components/Input';
import ImageInput from '../Modules/ImageInput';
import { Container, Header, Row, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const formRef = useRef(null);
  const [modules, setModules] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [statusJob, setStatusJob] = useState('');
  const [description, setDescription] = useState('');
  const [apolloLevel, setApolloLevel] = useState('');
  const [business1, setBusiness1] = useState('');
  const [business2, setBusiness2] = useState('');
  const [business3, setBusiness3] = useState('');
  const [tech1, setTech1] = useState('');
  const [tech2, setTech2] = useState('');
  const [tech3, setTech3] = useState('');
  const [tech4, setTech4] = useState('');
  const [tech5, setTech5] = useState('');
  const [tech6, setTech6] = useState('');

  useEffect(() => {
    async function getDataModules() {
      const { data } = await api.get('/modules');
      setModules(data);
    }
    async function getDataJobs() {
      const { data } = await api.get('/jobs');
      setJobs(data);
    }
    getDataModules();
    getDataJobs();
  }, []);

  async function handleSubmit(data, { reset }) {
    const {
      company,
      title,
      type_job,
      local,
      area_job,
      remote_job,
      file_id,
      salary,
    } = data;

    const apollo_level = parseInt(apolloLevel);
    const business1_id = parseInt(business1);
    const business2_id = parseInt(business2);
    const business3_id = parseInt(business3);
    const development1_id = parseInt(tech1);
    const development2_id = parseInt(tech2);
    const development3_id = parseInt(tech3);
    const development4_id = parseInt(tech4);
    const development5_id = parseInt(tech5);
    const development6_id = parseInt(tech6);

    if (
      file_id &&
      company &&
      title &&
      type_job &&
      local &&
      area_job &&
      description &&
      remote_job &&
      apolloLevel &&
      salary
    ) {
      await api.post('/jobs', {
        file_id,
        status: statusJob,
        company,
        title,
        type_job,
        local,
        area_job,
        description,
        remote_job,
        apollo_level,
        salary,
        business1_id,
        business2_id,
        business3_id,
        development1_id,
        development2_id,
        development3_id,
        development4_id,
        development5_id,
        development6_id,
      });

      return toast.success('Job cadastrado com sucesso');
    }
    return toast.error('Preencha todos os campos');
  }

  async function handleDelete(id) {
    await api.delete(`/jobs/${id}`);
    return toast.success('Vaga deletada com sucesso');
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/jobs')}
        >
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Cadastre Vagas:</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div className="support">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p style={{ fontSize: 20 }}>Escolha uma imagem:</p>
              <ImageInput name="file_id" />
            </div>
            <div className="select">
              <span>Status da Vaga:</span>
              <select
                value={statusJob}
                onChange={(e) => setStatusJob(e.target.value)}
              >
                <option disabled>Seleciona uma opçāo</option>
                <option value="open">Aberto</option>
                <option value="closed">Fechado</option>
                <option value="paused">Pausado</option>
              </select>
            </div>
          </div>

          <div className="support">
            <Input name="company" type="text" placeholder="Nome da Empresa" />
            <Input name="title" type="text" placeholder="Título da Vaga" />
            <Input
              name="type_job"
              type="text"
              placeholder="Tipo da Vaga (Tempo Integral, Meio Período, Por Job...)"
            />
          </div>

          <div className="support">
            <Input
              name="local"
              type="text"
              placeholder="Local (Sāo Paulo/SP)"
            />
            <Input
              name="area_job"
              type="text"
              placeholder="Tags (Mobile, FullStack, BPM, DEVOPS)"
            />
            <Input
              name="remote_job"
              type="text"
              placeholder="Trabalho Remoto? (yes, no, partial)"
            />
            <Input name="salary" type="integer" placeholder="Salário R$" />
          </div>

          <textarea
            type="text"
            placeholder="Descreva sobre a vaga"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="select">
            <span>Nível Apollo:</span>
            <select
              value={apolloLevel}
              onChange={(e) => setApolloLevel(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              <option value={1}>Iniciante</option>
              <option value={2}>Básico</option>
              <option value={3}>Intermediário</option>
              <option value={4}>Avançado</option>
              <option value={5}>Master</option>
            </select>
          </div>

          <div className="select" style={{ marginTop: 30 }}>
            <span>Certificados de Negócios:</span>
            <span>Certificado #1</span>
            <select
              value={business1}
              onChange={(e) => setBusiness1(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #2</span>
            <select
              value={business2}
              onChange={(e) => setBusiness2(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #3</span>
            <select
              value={business3}
              onChange={(e) => setBusiness3(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
          </div>

          <div className="select" style={{ marginTop: 30 }}>
            <span>Certificados de Tecnologias:</span>
            <span>Certificado #1</span>
            <select value={tech1} onChange={(e) => setTech1(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #2</span>
            <select value={tech2} onChange={(e) => setTech2(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #3</span>
            <select value={tech3} onChange={(e) => setTech3(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #4</span>
            <select value={tech4} onChange={(e) => setTech4(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #5</span>
            <select value={tech5} onChange={(e) => setTech5(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #6</span>
            <select value={tech6} onChange={(e) => setTech6(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
          </div>

          <button className="form" type="submit">
            CADASTRAR
          </button>
        </Form>
      </Container>

      <Container>
        <h1>Listagem de Vagas:</h1>
        {jobs.map((job) => (
          <Row key={job.id}>
            <div className="title">
              {job.file ? <img src={job.file.url} alt="image_url" /> : null}
              <h3>
                #{job.id}:{job.title}
              </h3>
            </div>
            <div className="description">
              <div>
                <p>Empresa: {job.company} </p>
                <p>Local: {job.local}</p>
              </div>
              <div>
                <p>Tipo: {job.type_job} </p>
                <p>Remoto: {job.remote_job}</p>
              </div>
            </div>
            <div className="button">
              <button
                type="submit"
                className="row"
                onClick={() => history.push(`/updatejob/${job.id}`)}
              >
                <MdModeEdit size={20} color="#090f35" />
              </button>
              <button
                type="submit"
                className="row"
                onClick={() => handleDelete(job.id)}
              >
                <MdDelete size={20} color="#FF0000" />
              </button>
            </div>
          </Row>
        ))}
      </Container>
    </>
  );
}
